
export default {
    ASSET_NAME_MAX_LENGTH: 50,
    ASSET_TYPE_MAX_LENGTH: 5,
    ASSET_MAKE_MAX_LENGTH: 50,
    ASSET_MODEL_MAX_LENGTH: 50,
    ASSET_SERIALNO_MAX_LENGTH: 100,
    ASSET_DESCRIPTION_MAX_LENGTH: 255,
    NEW_ASSET_NAME: 'New Asset',
    BEACON_MAKE_MAX_LENGTH: 50,
    BEACON_MODEL_MAX_LENGTH: 50,
    BEACON_MAC_MAX_LENGTH: 17,
};
